import { alpha } from '@mui/system';
export var BackdropTheme = function (theme) { return ({
    defaultProps: {},
    styleOverrides: {
        root: {
            backgroundColor: alpha(theme.palette.greySecondary.main, 0.3),
        },
        invisible: {
            backgroundColor: alpha(theme.palette.greySecondary.main, 0),
        },
    },
}); };
export default BackdropTheme;
//# sourceMappingURL=theme.js.map